<template>
  <swiper
      :spaceBetween="10"
      :centeredSlides="true"
      :speed="3000"
      :loop="true"
      :autoplay="{
      delay:  0,

      disableOnInteraction: false,
    }"


      :slidesPerView="2"
      :breakpoints="{
        '600': {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    '820': {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    '1024': {
                      slidesPerView: 7,
                      spaceBetween: 10,
                    },
                    }"


      :modules="modules"
      class="mySwiper"

  >
    <swiper-slide><img src="images/skills/0.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/1.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/2.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/3.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/4.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/5.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/6.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/7.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/8.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/9.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/10.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/11.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/12.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/13.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/14.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/15.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/16.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/17.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/18.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/19.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/20.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/21.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/22.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/23.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/24.png" loading="lazy"></swiper-slide>
    <swiper-slide><img src="images/skills/25.png" loading="lazy"></swiper-slide>

  </swiper>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";


// import required modules
import { Autoplay} from "swiper";


export default {
  name: "VueSwiperAutoplay",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay,],
    };
  },
}
</script>

<style scoped>
img{
  width: 100px;
  min-height: 100px;
  max-height: 100px;
  margin: auto;
}

</style>